// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__-2vVY","inputWrap":"styles_inputWrap__3wgD0","input":"styles_input__3rcYq"};